import { faGear } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { memo, useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';

const loadingSteps = [
    'Loading bond market data',
    'Processing your screening criteria',
    'This is taking longer than usual—almost done'
];

const TableLazyLoading = (props: { isLoggedIn: boolean }) => {
    const [loadingText, setLoadingText] = useState(loadingSteps[0]);
    const [stepIndex, setStepIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setStepIndex((prev) => {
                const nextIndex = prev + 1;
                if (nextIndex < loadingSteps.length) {
                    setLoadingText(loadingSteps[nextIndex]);
                    return nextIndex;
                } else {
                    clearInterval(interval); // ⛔ Stop when we reach the last step
                    return prev;
                }
            });
        }, 1000);

        return () => clearInterval(interval); // 🧼 Cleanup on unmount
    }, []);
    return (
        <>
            {[...Array(10).keys()].map((index) => {
                return (
                    <React.Fragment key={index}>
                        <tr style={{zIndex: 1}}>
                            <td style={{minWidth: 200}}>
                                <Skeleton height='8' />
                                <Skeleton height='8' width="35%" />
                            </td>
                            <td style={{minWidth: 150}}>
                                <Skeleton height='8' />
                                <Skeleton height='8' width="15%" />
                            </td>
                            <td>
                                <Skeleton height='8' />
                                <Skeleton height='8' width="11%" />
                            </td>
                            <td>
                                <Skeleton height='8' />
                                <Skeleton height='8' width="11%" />
                            </td>
                            <td>
                                <Skeleton height='8' />
                                <Skeleton height='8' width="11%" />
                            </td>
                            <td>
                                <Skeleton height='8' />
                                <Skeleton height='8' width="0%" />
                            </td>
                            {props.isLoggedIn && (
                                <td>
                                    <Skeleton height='8' />
                                    <Skeleton height='8' width="0%" />
                                </td>
                            )}
                        </tr>
                        {index === 3 && (
                            <tr key={'spinner'}>
                                <td colSpan={7}>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <FontAwesomeIcon icon={faGear} className="me-2 shibui-text" spin />
                                        <span className="fs-6">{loadingText}...</span>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default memo(TableLazyLoading);
